import * as React from 'react';
import CKEditor from 'src/modules/commons/inputs/rich-text/CKEditor';

interface Props {
  comment: string;
  handleChange: (value: string) => void;
  handleSubmit: () => void;
}

class ProjectCommentInputComponent extends React.Component<Props> {

  public render(): React.ReactNode {
    return (
      <div>
        <CKEditor
          content={this.props.comment}
          events={{
            'change': this.props.handleChange
          }}
        />
        <div className="gap-20"/>
        <button
          className="btn btn-primary margin-r-10"
          onClick={() => this.props.handleSubmit()}
        >
          Comentar
        </button>
      </div>
    );
  }
}

export default ProjectCommentInputComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/comments/ProjectCommentInput.component.tsx